/* eslint-disable react/prop-types */
import { Typography } from '@material-ui/core';
import React from 'react';
import empty from '../../../shared/img/empty2.png';

const Empty = ({ message }) => (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  }}
  >
    <img
      src={empty}
      alt="no data"
      style={{ width: '300px' }}
      aria-hidden="true"
    />
    <Typography style={{ color: '#a0a0a0' }}>{message}</Typography>
  </div>
);

export default Empty;
